import { Middleware } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { getCurrentUser } from "../../utils/firebase";
import { fetchAccessTokenSuccess } from "../slices/accessToken/accessTokenSlice";

const firebaseAuthMiddleware: Middleware = (store) => (next) => async (action: any) => {
  if (action.payload?.requiresAccessToken) {
    console.log('firebaseAuthMiddleware running', action.type);
    
    const currentUser = await getCurrentUser()
  
    if (!currentUser)
      return next(action)
  
    currentUser.getIdToken()
      .then((token) => {
        const state: RootState = store.getState()
        // Update the redux state if the access token has changed
        if (token !== state.accessToken.body) {
          store.dispatch(fetchAccessTokenSuccess({
            authId: currentUser.uid,
            tokens: {
              accessToken: token,
            },
          }))
        }
  
        next(action);
      })
      .catch((error) => {
        console.warn(error);
        next(action)
      })
  } else {
    next(action)
  }
}

export default firebaseAuthMiddleware;